import { useHttpClient } from '@/common/api/httpClient';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';

export interface OutboundDeliveryTransactionResponse {
  transactionTimeUtc: Date;
  userId: string;
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  comment: string | null;
}

export interface OutboundDeliveryTransactionResult {
  ok: true;
  transactions: OutboundDeliveryTransactionResponse[];
}

export function useListOutboundDeliveryTransactionApi() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute(deliveryId: string) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`delivery/outbound/transaction/${deliveryId}`), {
      headers,
    });

    const title = translations.value.outboundDelivery.actions.fetchTransactions.title;
    const error = translations.value.outboundDelivery.actions.fetchTransactions.error;

    const response = await httpClient.action<OutboundDeliveryTransactionResult>(request, {
      title: title,
      errorTitle: error,
      async processOk(response) {
        const transactions = (await response.json()) as OutboundDeliveryTransactionResponse[];

        return {
          ok: true,
          transactions: transactions,
        };
      },
    });

    return response;
  }
}
